var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 70,
    viewBox: "0 0 101 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51862 50.4711H8.52386C15.2088 57.0075 26.0573 63.1193 41.8629 66.5207C79.5859 74.6469 84.8786 62.7294 95.2482 47.5676C95.5145 47.175 95.7716 46.7877 96.013 46.3932C99.9973 40.0191 101.374 33.0678 100.288 26.5412C100.284 26.5014 100.278 26.4618 100.269 26.4228C100.239 26.2501 100.21 26.0826 100.175 25.9092C100.126 25.643 100.071 25.3813 100.012 25.1196C97.8004 15.2361 89.8521 6.49229 76.6706 2.42493C71.0228 0.747255 65.1541 -0.0688207 59.2628 0.00426308C58.4084 0.00426308 57.5396 0.023898 56.6609 0.0533385C56.3698 0.0631519 56.0787 0.0781824 55.7823 0.0932297C53.1654 0.216225 50.4394 0.479465 47.6044 0.882908C35.9133 2.56167 27.7923 4.60025 22.0455 6.82726C13.184 10.2633 9.94223 14.1631 7.89645 17.94V17.9453C6.16339 21.1543 5.2998 24.2743 2.60436 26.9547C-2.01648 31.5376 -0.747927 41.4067 8.51862 50.4711Z",
    fill: "url(#paint0_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.863 66.5208C79.586 74.647 84.8787 62.7295 95.2483 47.5677C99.8194 40.8788 101.444 33.4729 100.286 26.5413C101.987 39.0319 87.4773 60.4652 60.1219 62.6274C31.6851 64.8741 7.42746 49.6566 3.12261 40.3005C-0.748478 31.8831 5.49682 25.4304 7.89131 17.9467C6.15825 21.1557 5.29467 24.2757 2.59924 26.9561C-5.3438 34.8402 4.13994 58.3998 41.863 66.5208Z",
    fill: "url(#paint1_linear_2_12045)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1561 15.8706C103.028 30.8119 86.5051 56.6475 47.8524 51.657C9.19971 46.6665 12.1856 30.0864 13.905 23.9961C15.6243 17.9059 14.8634 6.4241 39.4148 3.08621C63.9661 -0.25168 68.1539 3.50492 74.2441 8.04071C80.3344 12.5765 84.1413 15.0201 85.1561 15.8706Z",
    fill: "url(#paint2_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9551 23.2775C90.9551 23.2775 96.0634 39.2008 76.9807 46.4373C57.8981 53.6737 39.5639 51.5514 25.4704 43.07C11.3769 34.5885 14.2451 26.3576 14.9935 22.6154C15.742 18.8732 16.0887 15.973 16.0887 15.973C16.0887 15.973 13.8709 23.6275 12.2497 27.0498C10.6285 30.4721 14.932 51.821 48.4817 54.0768C82.0314 56.3325 97.9456 41.0281 90.9551 23.2775Z",
    fill: "url(#paint3_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52393 50.4712C15.2089 57.0076 26.0573 63.1194 41.8629 66.5208C79.586 74.647 84.8787 62.7295 95.2483 47.5677C95.5145 47.1752 95.7717 46.7879 96.0131 46.3934C96.0131 46.3934 78.6648 63.949 59.7516 65.124C40.8384 66.299 9.80295 51.779 8.52393 50.4712Z",
    fill: "url(#paint4_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7175 44.5432C85.0671 39.1785 55.6326 13.4639 33.8061 15.9703C11.9796 18.4767 18.1156 35.7621 39.5437 44.9174C60.9718 54.0728 73.7175 44.5432 73.7175 44.5432Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3209 17.2288C86.5319 27.23 56.256 19.9726 40.0421 14.4849C23.8283 8.99723 47.8438 0.440517 61.9654 4.03291C76.087 7.62529 82.7582 15.4768 83.3209 17.2288Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2388 27.0469C83.8698 24.8029 69.7914 22.6963 67.2006 24.3999C64.6098 26.1036 71.5971 29.694 78.2388 27.0469Z",
    fill: "#9ADD00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7713 7.82105C65.7713 7.82105 68.0977 8.98755 68.1265 10.6781C68.1265 10.6781 70.9737 11.9172 71.6332 13.1524C72.2927 14.3876 63.6935 16.54 53.7982 15.5004C39.4901 13.9957 40.355 10.4275 40.355 10.4275C40.355 10.4275 44.3714 4.74286 47.5261 5.22896C47.5261 5.22896 47.0975 1.13675 49.9794 1.92314L50.1554 3.8348C51.0869 3.98566 51.9421 4.44111 52.5872 5.12985C53.2322 5.81858 53.6308 6.70174 53.7203 7.64112C53.7203 7.64112 54.6598 8.52369 53.9094 9.09222C53.9094 9.09222 56.9032 6.98297 60.19 11.1164C60.464 10.6851 60.8177 10.3101 61.2322 10.0114C61.2322 10.0114 61.8825 4.38895 65.7713 7.82105Z",
    fill: "url(#paint5_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5412 12.0443C70.5412 12.0443 71.2909 14.6239 61.5782 15.0308C51.8655 15.4378 42.2051 12.7089 42.2051 12.7089C42.2051 12.7089 45.0333 15.6262 59.7862 16.3772C74.5392 17.1283 72.9723 13.7001 72.7355 13.3403C72.4986 12.9804 70.5412 12.0443 70.5412 12.0443Z",
    fill: "url(#paint6_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7906 8.49487C67.134 8.8167 67.3712 9.23555 67.4706 9.6956C67.5699 10.1557 67.5267 10.6351 67.3467 11.07C66.735 12.6512 64.1226 12.2279 62.8717 11.6018C62.16 11.2725 61.5808 10.7119 61.2283 10.0114C60.8473 10.3465 60.4984 10.7165 60.1861 11.1164C60.1861 11.1164 62.1266 12.4628 62.4177 13.6214C62.7088 14.7801 56.0134 14.9149 53.4057 12.5145C50.7979 10.1141 54.1404 8.95676 54.1404 8.95676C54.1404 8.95676 52.4937 8.76835 51.8833 11.0228C51.2729 13.2773 53.9166 14.7834 59.4802 14.7663C65.0438 14.7493 63.5744 13.4023 64.8305 12.9954C66.0867 12.5884 67.6051 11.6175 67.8642 11.1478L68.1259 10.6781C68.0965 10.2333 67.9597 9.80229 67.7271 9.42203C67.4946 9.04178 67.1732 8.7236 66.7906 8.49487Z",
    fill: "url(#paint7_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5228 5.22876C47.5228 5.22876 49.8126 5.68674 50.8738 9.01875C50.8738 9.01875 51.2905 7.90657 49.8997 5.96677C48.5088 4.02697 47.479 4.86962 47.479 4.86962L47.5228 5.22876Z",
    fill: "url(#paint8_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7197 7.641C53.7197 7.641 52.0154 7.61745 51.4992 8.5916C51.4992 8.5916 51.089 5.89093 52.0932 5.43297C53.0975 4.97501 53.7197 7.641 53.7197 7.641Z",
    fill: "url(#paint9_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8468 11.6304C61.9387 12.6379 61.4886 14.0288 57.1831 13.4178C52.8776 12.8067 53.0536 10.0812 53.7464 9.53489C54.4392 8.98861 56.8213 7.91698 60.8468 11.6304Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1844 9.15939C67.9564 9.94447 68.2344 12.197 64.4294 11.7109C60.6244 11.2248 61.4167 7.96866 62.9698 7.32751C64.5229 6.68637 67.1844 9.15939 67.1844 9.15939Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.739 11.7793C70.9409 11.8447 70.1898 13.6707 67.9412 14.164C65.6926 14.6573 64.6701 14.5139 64.5196 14.4361C64.3691 14.3582 65.3904 11.5496 69.739 11.7793Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8352 13.5677C52.673 13.1817 50.7417 6.27893 47.5797 5.66788C44.4178 5.05682 41.4437 8.79185 41.3933 10.7408C41.343 12.6898 48.4453 14.0695 50.8352 13.5677Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9731 45.5408C54.1559 45.1548 37.3604 28.5164 23.2362 29.2642C9.11201 30.0119 21.2696 46.2892 42.9731 45.5408Z",
    fill: "url(#paint10_linear_2_12045)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9234 37.4028C78.7009 40.9729 62.4302 46.1957 54.947 42.0799C47.4639 37.9641 59.702 34.0335 68.9234 37.4028Z",
    fill: "url(#paint11_linear_2_12045)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.828 45.2606C47.8846 43.7631 39.8395 32.912 28.9419 31.2287C18.0444 29.5453 17.1658 33.3798 17.1658 33.3798C17.1658 33.3798 18.0895 40.6765 29.5962 44.3245C41.1028 47.9725 44.828 45.2606 44.828 45.2606Z",
    fill: "#86A500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.666 40.7169C71.666 40.7169 71.9715 36.9112 62.1967 36.7915C52.4218 36.6718 52.7953 40.1857 52.7953 40.1857C52.7953 40.1857 53.848 43.2723 61.5418 43.5877C69.2355 43.903 71.6778 40.9282 71.666 40.7169Z",
    fill: "#639100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3547 36.0922C82.3847 33.8952 79.0606 32.2387 76.6851 35.1383C74.3096 38.0378 82.3095 39.2802 82.3547 36.0922Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1217 35.0803C82.1795 35.3694 82.1758 35.6675 82.1108 35.9552C82.0458 36.2428 81.9208 36.5136 81.7442 36.7497C81.5675 36.9859 81.3431 37.1822 81.0855 37.3258C80.828 37.4694 80.543 37.5572 80.2493 37.5833C77.9424 38.0197 76.1276 36.6949 76.5201 35.3622C76.1374 35.7087 75.8674 36.162 75.7449 36.6635C75.5728 37.459 77.4282 38.8931 80.8427 38.6438C84.2571 38.3946 82.6503 35.7953 82.1217 35.0803Z",
    fill: "#DB83A9"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9346 34.8342C78.7256 34.8342 78.6255 36.0425 77.3733 35.9333C76.1211 35.824 77.3498 34.8342 77.9346 34.8342Z",
    fill: "#E7792C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6493 41.3388C81.667 40.0427 79.7063 39.0653 78.3049 40.7755C76.9035 42.4856 81.6232 43.219 81.6493 41.3388Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5121 40.7428C81.5462 40.9134 81.544 41.0893 81.5057 41.259C81.4673 41.4287 81.3937 41.5885 81.2895 41.7278C81.1853 41.8672 81.0529 41.983 80.901 42.0678C80.7491 42.1526 80.581 42.2045 80.4077 42.2201C79.0463 42.4772 77.9753 41.6967 78.2075 40.9116C77.9816 41.1161 77.8221 41.3836 77.7496 41.6797C77.6488 42.1487 78.7427 42.9947 80.759 42.8474C82.7754 42.7002 81.8241 41.1648 81.5121 40.7428Z",
    fill: "#DB83A9"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0383 40.5965C79.5054 40.5965 79.4459 41.3096 78.7073 41.2449C77.9686 41.1801 78.6968 40.5965 79.0383 40.5965Z",
    fill: "#E7792C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5258 57.7732C81.5127 53.3048 61.4945 55.9243 40.822 53.679C20.1496 51.4337 7.7081 39.7916 5.74344 39.8603C3.77878 39.929 10.6077 55.6436 39.8865 60.8814C69.1653 66.1192 75.5258 57.7732 75.5258 57.7732Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1836 15.0977C11.1836 15.0977 11.5761 17.4529 18.318 19.502C22.8492 20.8805 30.225 17.6702 31.9699 16.2596C33.7147 14.8491 35.5302 14.1615 29.3614 12.3951C23.1927 10.6286 11.1836 15.0977 11.1836 15.0977Z",
    fill: "#DB83A9"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3862 14.1448C32.0208 13.3669 29.6002 6.9711 27.4294 5.94003C25.2587 4.90896 20.859 -0.353702 18.5057 0.608019C15.0716 2.01135 10.5424 13.5886 10.3683 14.2991C10.1943 15.0096 13.9588 17.2196 18.575 18.4692C23.1913 19.7188 30.2092 15.5841 31.3862 14.1448Z",
    fill: "url(#paint12_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1822 14.1012C32.2074 12.7737 29.8495 9.00666 27.4295 8.26476C25.0095 7.52286 19.4322 17.7086 19.9896 18.2025C20.547 18.6965 27.3209 19.1028 31.1822 14.1012Z",
    fill: "#DB83A9"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9633 6.29392C28.452 6.67926 24.6025 11.3897 18.0589 11.2085C10.3625 10.9952 16.3206 1.52193 18.5057 0.606006C20.4095 -0.192157 25.8115 4.59684 27.9633 6.29392Z",
    fill: "#D96840"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2964 11.4345C22.9794 11.4848 21.758 14.6179 19.0782 15.7714C18.2584 16.1344 17.3644 16.2985 16.4692 16.2501C15.5739 16.2018 14.7027 15.9425 13.9268 15.4933C13.5624 15.2846 16.3049 10.9922 22.2964 11.4345Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3074 6.63947C26.8779 7.72942 26.6999 9.74708 20.9224 10.0297C15.1448 10.3123 20.4278 5.91853 22.8471 5.71179C25.2665 5.50505 26.1026 6.2417 26.3074 6.63947Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5273 10.8084C31.3241 12.0247 23.0356 15.7512 22.4226 15.4914C21.8096 15.2317 24.1681 10.2118 26.5273 10.8084Z",
    fill: "#9ADD00"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9869 8.64954C25.3988 9.56775 24.7231 10.4269 23.9693 11.2148C23.1646 11.9168 20.9258 11.4163 20.9258 11.4163C22.5525 10.3877 24.2429 9.46354 25.9869 8.64954Z",
    fill: "#B2562B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9161 6.68701C27.3615 7.3594 26.7115 7.94703 25.9868 8.4312C24.273 9.31855 22.4887 10.0625 20.6522 10.6556C19.4043 11.0414 18.0936 11.1823 16.7922 11.0704C16.7922 11.0704 20.049 11.5937 20.9263 11.2993C21.8037 11.0049 24.2184 9.28301 25.8226 8.89832C26.6997 8.35437 27.421 7.59253 27.9161 6.68701Z",
    fill: "#EA8E40"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8766 2.38034C23.0729 2.88737 18.3945 7.50164 16.7923 8.04334C15.1901 8.58505 17.1796 1.85041 18.4671 1.04309C19.7547 0.235767 22.8766 2.38034 22.8766 2.38034Z",
    fill: "#DB83A9"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3179 0.692383C18.3179 0.692383 17.7612 1.89618 17.0814 3.76728C16.4867 5.09358 15.5907 6.26274 14.4645 7.18171C14.4645 7.18171 14.1891 3.76596 18.3179 0.692383Z",
    fill: "#EA8E40"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4402 60.3648C71.889 59.2526 71.8622 55.9526 69.9132 54.567C67.9643 53.1813 63.3186 55.0851 60.9332 57.7727C58.5479 60.4603 60.0723 61.8944 63.9636 62.2078C67.855 62.5211 71.0908 61.2303 71.4402 60.3648Z",
    fill: "#EDE0A9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8304 54.7142C59.7719 55.6341 59.5769 56.9059 57.7065 57.2801C55.836 57.6543 54.2921 55.8663 54.1514 55.2219C54.0107 54.5775 58.2207 54.1182 58.8304 54.7142Z",
    fill: "#EDE0A9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9667 60.3682C49.0027 59.3097 47.5391 57.5616 44.9229 56.0654C42.3066 54.5692 34.8935 57.0212 34.1104 57.6656C33.3273 58.31 40.3079 63.8291 46.9667 60.3682Z",
    fill: "#EDE0A9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9107 54.4384C36.6788 55.4688 34.6023 56.5784 33.4318 55.2693C32.2614 53.9601 35.3965 53.7475 35.9107 54.4384Z",
    fill: "#EDE0A9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1359 59.103C33.9023 58.0857 32.8555 52.3245 27.5562 51.5473C22.2569 50.7701 26.0665 62.6006 32.1359 59.103Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5587 58.1791C47.5587 58.1791 47.4795 61.8082 41.8394 61.1474C33.8578 60.2119 34.8496 57.2828 34.8496 57.2828C34.5119 57.4524 34.1912 57.6537 33.8918 57.8841C33.6739 58.1026 35.8839 61.2861 41.5895 61.7441C47.295 62.202 48.2155 59.8396 48.1534 59.341C48.0402 58.9158 47.8374 58.5197 47.5587 58.1791Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9109 54.4384C35.9109 54.4384 36.3787 55.5264 34.9053 55.5506C33.432 55.5748 33.1729 54.6615 33.1729 54.6615C33.1729 54.6615 32.9642 56.0949 34.9289 56.1008C36.8935 56.1067 35.9109 54.4384 35.9109 54.4384Z",
    fill: "#CC81B3"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7662 45.5914C18.5336 46.6218 16.4578 47.7314 15.2873 46.4222C14.1169 45.1131 17.2514 44.9005 17.7662 45.5914Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7662 45.591C17.7662 45.591 18.2333 46.679 16.76 46.7032C15.2867 46.7274 15.0276 45.8141 15.0276 45.8141C15.0276 45.8141 14.8196 47.2475 16.7836 47.2534C18.7476 47.2593 17.7662 45.591 17.7662 45.591Z",
    fill: "#CC81B3"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.329 61.8181C59.8923 62.5744 58.3685 63.3883 57.5115 62.4278C56.6545 61.4674 58.9534 61.3117 59.329 61.8181Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3289 61.8183C59.3289 61.8183 59.6718 62.6165 58.5916 62.6335C57.5115 62.6505 57.3211 61.9793 57.3211 61.9793C57.3211 61.9793 57.168 63.0306 58.6086 63.0365C60.0492 63.0424 59.3289 61.8183 59.3289 61.8183Z",
    fill: "#CC81B3"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0648 57.2744C55.6274 58.3003 54.1044 59.4046 53.2467 58.1014C52.389 56.7982 54.6873 56.5875 55.0648 57.2744Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0647 57.2745C55.0647 57.2745 55.4075 58.3573 54.3267 58.3808C54.0445 58.4079 53.7618 58.3339 53.529 58.1718C53.2963 58.0098 53.1288 57.7704 53.0562 57.4963C53.029 57.6785 53.0423 57.8644 53.0953 58.0408C53.1483 58.2173 53.2395 58.3798 53.3626 58.5169C53.4857 58.6539 53.6375 58.7621 53.8072 58.8337C53.9769 58.9053 54.1603 58.9385 54.3444 58.931C55.7844 58.9395 55.0647 57.2745 55.0647 57.2745Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.272 56.4379C71.272 56.4379 71.7725 60.0186 69.0247 61.1157C66.4684 62.0141 63.6932 62.0796 61.0974 61.3028C59.624 60.7179 59.8543 59.5423 59.8543 59.5423C59.7488 59.8823 59.7193 60.2414 59.7678 60.5941C59.8163 60.9468 59.9416 61.2845 60.135 61.5835C60.7892 62.7526 68.5536 63.1268 70.869 61.747C73.1843 60.3672 71.272 56.4379 71.272 56.4379Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0634 54.98C59.1825 55.2179 59.2224 55.4877 59.1774 55.7499C59.1323 56.0122 59.0046 56.2531 58.8128 56.4376C58.1324 57.0761 56.3653 57.1396 55.2276 56.2825C54.0899 55.4255 54.2083 55.0618 54.2083 55.0618C54.1527 55.1584 54.12 55.2665 54.1128 55.3777C54.3777 55.9794 54.8026 56.4968 55.3414 56.8735C55.8802 57.2502 56.512 57.4716 57.1681 57.5138C59.3277 57.7402 60.0768 56.1563 59.0634 54.98Z",
    fill: "#CC81B3"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5949 54.0327C78.0152 55.1906 77.4264 57.3372 74.8324 57.9822C73.0358 58.4291 71.9282 56.6614 71.8353 56.0196C71.7424 55.3778 75.7829 53.3706 76.5949 54.0327Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9187 54.3665C77.0742 54.7739 77.1003 55.2194 76.9936 55.6422C76.8868 56.0651 76.6523 56.4447 76.3221 56.7295C75.3486 57.6991 73.5023 57.8594 72.5929 56.9912C71.7967 56.2362 71.8733 55.8417 71.8733 55.8417C71.8355 55.9523 71.8134 56.0678 71.8079 56.1846C71.9574 56.7373 72.2694 57.2323 72.7036 57.6056C73.1378 57.9789 73.674 58.2131 74.2429 58.2781C76.8919 58.6006 78.4745 56.0027 76.9187 54.3665Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5225 55.3037C32.5225 55.3037 33.1571 57.1034 32.1351 58.2411C31.1132 59.3789 29.2225 59.4188 27.1015 57.4698C26.4829 56.9109 25.9887 56.2282 25.6512 55.4659C25.3136 54.7037 25.1401 53.8789 25.1421 53.0452C24.898 53.9378 24.898 54.8795 25.1421 55.7721C25.4329 57.0873 26.1772 58.2583 27.2446 59.0799C28.3121 59.9016 29.6345 60.3214 30.9804 60.266C34.6238 60.2274 32.9686 55.8192 32.5225 55.3037Z",
    fill: "#CC81B3"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7018 63.8924C57.3184 62.8986 55.7529 58.6029 50.5334 58.6474C45.3139 58.6919 50.1408 67.3101 55.7018 63.8924Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7151 60.9305C55.7151 60.9305 56.5034 62.235 55.6196 63.2321C54.7357 64.2291 52.9032 64.4869 50.6566 63.2484C50.0369 62.9565 49.4998 62.5148 49.0937 61.9632C48.6876 61.4116 48.4254 60.7675 48.3308 60.0891C48.1778 60.796 48.2686 61.534 48.5885 62.1827C49.1158 63.5605 51.1518 65.3962 54.6886 64.9259C58.2254 64.4555 56.1966 61.272 55.7151 60.9305Z",
    fill: "#CC81B3"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75533 31.0415C9.78607 28.8446 6.46127 27.1881 4.08575 30.0876C1.71023 32.9872 9.70953 34.2296 9.75533 31.0415Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52102 30.032C9.57899 30.3211 9.57536 30.6192 9.5104 30.9069C9.44544 31.1945 9.3206 31.4653 9.14399 31.7014C8.96739 31.9376 8.74301 32.1339 8.48546 32.2775C8.22791 32.4211 7.94299 32.5089 7.64925 32.5351C5.34178 32.9714 3.52759 31.6466 3.92013 30.3107C3.53714 30.657 3.26685 31.1103 3.14421 31.6119C2.9728 32.4075 4.82821 33.8415 8.24199 33.5923C11.6558 33.343 10.0496 30.7444 9.52102 30.032Z",
    fill: "#DB83A9"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33382 29.7807C6.12544 29.7807 6.02469 30.9897 4.77249 30.8798C3.52029 30.7699 4.74893 29.7807 5.33382 29.7807Z",
    fill: "#E7792C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7378 48.0618C59.5095 47.0307 56.941 46.2542 54.1121 47.015C51.2832 47.7759 55.1654 49.558 57.7378 48.0618Z",
    fill: "#B0FF00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9373 44.5067C56.4607 44.8554 56.218 45.4082 55.0018 44.8874C53.7856 44.3667 55.0279 43.8989 55.9373 44.5067Z",
    fill: "#B0FF00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0628 47.2551C48.4216 47.5508 47.2578 49.8975 42.9581 49.3244C38.6585 48.7513 43.4698 47.1144 45.0628 47.2551Z",
    fill: "#B0FF00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3081 45.2049C48.6859 45.532 46.8717 46.4093 46.6225 46.23C46.3732 46.0508 46.7003 45.0603 47.3081 45.2049Z",
    fill: "#B0FF00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4792 31.0843C41.0824 32.4052 37.7668 31.6921 37.0655 30.523C36.3641 29.3538 39.4972 28.9305 40.4792 31.0843Z",
    fill: "#B0FF00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3303 39.86C51.5685 40.8348 49.9741 40.825 49.3676 39.86C48.7612 38.8951 51.1432 39.0946 51.3303 39.86Z",
    fill: "#B0FF00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.807 45.5654C56.3117 46.1692 54.4367 46.9491 52.2679 46.7103C50.0991 46.4715 53.0922 44.8778 54.807 45.5654Z",
    fill: "#B0FF00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8946 44.2197C75.2413 44.8831 72.5177 45.8134 71.0837 45.5654C69.6496 45.3175 70.996 43.6832 72.8946 44.2197Z",
    fill: "#B0FF00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1458 36.4318C71.7818 36.7851 70.7402 37.2764 70.1789 36.7917C69.6176 36.3069 70.5845 36.1198 71.1458 36.4318Z",
    fill: "#B0FF00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8473 37.6885C43.1256 39.8586 36.7815 48.0908 23.6334 44.4532C10.4853 40.8157 26.2176 34.8184 35.8473 37.6885Z",
    fill: "#DB83A9"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3141 41.0686C34.4819 39.8014 35.4214 33.6758 30.1856 30.9745C24.9498 28.2732 18.7679 34.3523 17.996 36.6781C17.224 39.0039 20.9184 42.4151 22.7437 43.3257C24.569 44.2364 30.3636 44.2737 33.3141 41.0686Z",
    fill: "url(#paint13_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6386 33.7718C33.0308 35.8438 31.6844 41.5002 26.601 42.021C21.5176 42.5417 18.3086 37.5415 19.5451 35.0724C20.7816 32.6033 29.0517 29.9223 31.6386 33.7718Z",
    fill: "#DB83A9"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9239 32.5811C32.4374 33.7319 28.9406 37.0658 26.1241 38.1237C23.3076 39.1816 18.6881 36.8807 18.4205 36.5941C18.1529 36.3076 23.6616 30.1735 27.307 30.2971C30.9523 30.4208 31.9239 32.5811 31.9239 32.5811Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6366 43.5406C28.6141 43.9489 32.3707 42.418 33.3743 40.4115C34.3779 38.4049 33.2271 33.7769 33.0373 33.4982C32.8476 33.2195 27.4901 37.9698 26.6016 38.6555C25.7132 39.3411 27.2945 43.3973 27.6366 43.5406Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7417 43.6022C27.1343 43.4714 26.569 40.1616 25.695 39.3562C24.8209 38.5509 18.6829 37.3935 18.3872 37.402C18.0915 37.4105 19.1199 43.8587 26.7417 43.6022Z",
    fill: "#DB83A9"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.654 36.7217C27.8986 37.7503 27.0502 38.7074 26.1195 39.5807C24.97 39.2123 23.8416 38.7814 22.7391 38.2899C22.6468 38.2068 26.1404 37.5964 28.654 36.7217Z",
    fill: "#FFFFF0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2788 37.8522C21.2788 37.8522 19.8715 37.6906 19.0446 37.4995C18.2176 37.3085 18.1424 36.5352 18.2333 36.4606C18.3242 36.386 19.5457 37.245 21.2788 37.8522Z",
    fill: "#FFFFF0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0973 36.6504C30.0358 35.6586 28.5808 32.1538 25.1323 32.1283C21.6839 32.1028 20.4919 35.2353 20.344 36.3259C20.1961 37.4165 23.7996 38.8506 28.0973 36.6504Z",
    fill: "#FFB5E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3097 41.3609C40.3162 41.6356 45.0692 44.4573 40.1369 44.9984C35.2047 45.5394 32.8324 44.2519 32.1618 43.0828C31.4913 41.9137 35.5442 40.9814 38.3097 41.3609Z",
    fill: "#DB83A9"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2047 43.4382C39.6699 43.2237 39.403 39.102 37.9054 37.9257C36.4079 36.7494 31.9584 37.2512 31.1668 38.5367C30.3752 39.8223 32.1076 43.5894 34.1802 43.787C36.2528 43.9845 37.2047 43.4382 37.2047 43.4382Z",
    fill: "url(#paint14_linear_2_12045)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6323 39.1365C39.2832 40.5758 36.1534 42.4155 33.7334 41.6795C31.3134 40.9435 31.2578 39.1686 31.6771 38.5039C32.0965 37.8392 37.4357 36.4927 38.6323 39.1365Z",
    fill: "#DB83A9"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9054 37.9255C38.2678 38.5594 35.9924 39.9248 34.4131 40.1642C32.8338 40.4037 30.9758 39.2018 31.0831 38.7046C31.1903 38.2074 31.908 37.6088 34.0271 37.3353C36.1462 37.0618 37.7883 37.7213 37.9054 37.9255Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.273 42.774C37.9445 43.0904 37.5483 43.3278 37.1143 43.4683C36.6804 43.6087 36.2202 43.6485 35.7686 43.5847C35.361 43.4093 34.538 40.5628 34.7127 40.3135C34.8874 40.0642 37.677 38.6831 37.9498 38.462C38.2227 38.2409 39.5553 40.4064 38.273 42.774Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.265 43.5952C35.5456 43.6083 34.5676 40.9188 34.2784 40.6198C33.9892 40.3208 32.3393 40.1559 31.2251 39.3728C31.2251 39.3728 31.3468 41.658 32.6369 42.7807C32.9858 43.1049 33.4032 43.3465 33.8581 43.4875C34.3131 43.6285 34.7939 43.6653 35.265 43.5952Z",
    fill: "#DB83A9"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4201 39.8992C35.2418 40.3609 34.9868 40.7892 34.6657 41.1658C34.5617 41.1403 33.0864 40.1053 33.0864 40.1053C33.8683 40.0937 34.6483 40.0248 35.4201 39.8992Z",
    fill: "#FFFFF0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.817 38.4007C37.5675 38.8119 37.2094 39.1463 36.782 39.367C36.3655 39.6055 35.9191 39.7874 35.4546 39.9081C35.4546 39.9081 36.6106 39.2172 37.817 38.4007Z",
    fill: "#FFFFF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_12045",
    x1: -78.4019,
    y1: 69.1532,
    x2: -78.4019,
    y2: -0.000244141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_12045",
    x1: -78.4031,
    y1: 69.1533,
    x2: -78.4031,
    y2: 17.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#E1806E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#F1AD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBC95C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_12045",
    x1: -80.7878,
    y1: 52.2871,
    x2: -80.7878,
    y2: 1.80963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_12045",
    x1: -80.4227,
    y1: 54.2983,
    x2: -80.4227,
    y2: 15.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_12045",
    x1: -80.365,
    y1: 69.1533,
    x2: -80.365,
    y2: 46.3934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_12045",
    x1: -71.6691,
    y1: 15.092,
    x2: -71.6691,
    y2: 1.19487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#457400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_12045",
    x1: -73.0134,
    y1: 15.7962,
    x2: -73.0134,
    y2: 11.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_12045",
    x1: -75.7306,
    y1: 14.0829,
    x2: -75.7306,
    y2: 7.83635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_12045",
    x1: -65.4617,
    y1: 8.3604,
    x2: -65.4617,
    y2: 4.04648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E765E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_12045",
    x1: -69.9288,
    y1: 6.3371,
    x2: -67.5839,
    y2: 6.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_12045",
    x1: -74.729,
    y1: 37.4027,
    x2: -45.2749,
    y2: 37.4027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_12045",
    x1: -100.088,
    y1: 39.8596,
    x2: -80.7514,
    y2: 39.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_12045",
    x1: -49.0454,
    y1: 18.7014,
    x2: -49.0454,
    y2: 0.491211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_12045",
    x1: -81.1923,
    y1: -15.1694,
    x2: -82.9908,
    y2: -33.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_12045",
    x1: -90.8226,
    y1: -17.692,
    x2: -91.6706,
    y2: -26.6714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.db86c8b92c79e63afb1e27cdb8ff35ce.svg";
export { ForwardRef as ReactComponent };